module.exports = __webpack_public_path__ + "static/media/down-arrow.54529900.svg";